export enum EMarkingTypes {
  IMPORT = 'IMPORT',
  EXPORT = 'EXPORT',
  DEACTIVATION = 'DEACTIVATION',
  CONFISCATION = 'CONFISCATION',
  SURPLUS_SALE = 'SURPLUS_SALE',
  APPLIED = 'APPLIED',
}
